import * as React from 'react';
import { ApiStore } from '../../../stores/ApiStore';
import { bind, inject } from '../../../utils/decorators';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { FormGroup, Col, ControlLabel, FormControl, InputGroup, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import FaIcon from '../../site/FaIcon';

interface IFormularElementTextUebernahme {
  editable?: boolean;
  kategorieguid: string;
  elementguid: string;
  value?: string;
  platzhalter: string;
  text: string;
  werte: string;
  anr?: string;
  onHandleValidation?: (validationstate: 'success' | 'warning' | 'error' | undefined) => void;
}

/** Komponente für Übernahme eines Formulardatums aus einem anderen Vorgang einem Auftrag. Das zu übernehmende Formulardatum wird in der Vorlage (im QIT) definiert. */
@observer
export default class FormularElementTextUebernahme extends React.Component<IFormularElementTextUebernahme, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  @observable value: string = this.props.value ? this.props.value : '';
  @observable formularWert: string | null = null;

  popoverHint = (
    <Popover id="popover-trigger-hover-focus">
      Übernimmt, sofern vorhanden, Daten automatisch aus einem anderen Vorgang in diesem Auftrag.
    </Popover>
  );

  @bind @action setFormularWert(wert: string | null) {
    this.formularWert = wert;
  }

  async sucheFormularDatum(anr: string, kuerzel: string) {
    const dokumente = await this.apiStore.auftragFormularDatenSuche(anr, this.props.werte);
    if (dokumente.ok) {
      this.setFormularWert(dokumente.json.wert);
    }
  }

  @bind @action setWert(wert: string) {
    this.value = wert;
    if (this.props.onHandleValidation) {
      this.props.onHandleValidation(this.getValidationState());
    }
  }

  @bind @action uebernehmeFormularDatum() {
    if (this.props.anr) {
      this.sucheFormularDatum(this.props.anr, this.props.werte).then(resp => {
          this.setWert(this.formularWert || '');
        }
      );
    }
  }

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    this.setWert((event.target as HTMLInputElement).value);
  }

  private getValidationState() {
    if (!this.props.editable) {
      return undefined;
    }
    return (this.value.length > 0) ? 'success' : 'error';
  }

  render() {
    const validationState = this.getValidationState();
    let btnClass = 'btn-group';
    if (validationState === 'error') {
      btnClass += ' button-error';
    }
    if (validationState === 'success') {
      btnClass += ' button-success';
    }
    return (
      <FormGroup controlId={this.props.text} validationState={validationState} className="formular-element-row">
        <Col componentClass={ControlLabel} sm={9} className="formular-element-caption">{this.props.text}</Col>
        <Col componentClass={ControlLabel} sm={3} className="formular-element">
          <InputGroup>
            <FormControl readOnly={!this.props.editable} onChange={this.handleValueChanged} type="text" name={`${this.props.kategorieguid}[${this.props.elementguid}]`} value={this.value} placeholder={this.props.platzhalter}/>
              {/* Button zur Übernahme des Formulardatums wird nur angezeigt wenn Datensatz editiert werden darf */}
              {this.props.editable &&
              <OverlayTrigger trigger={['hover', 'focus', 'click']} placement="top" overlay={this.popoverHint}>
                <InputGroup.Button style={{width: '28px'}}>
                  <Button bsStyle="default" className={btnClass} disabled={false} onClick={this.uebernehmeFormularDatum}> <FaIcon icon="files-o" />
                  </Button>
                </InputGroup.Button>
              </OverlayTrigger>}
          </InputGroup>
        </Col>
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/formularelemente/FormularElementTextUebernahme.tsx